import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";
import axios from "axios";
import API_ENDPOINTS from "config/api";

export default function Productos() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const [productos, setProductos] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [busqueda, setBusqueda] = useState("");

  // Estados para modales
  const [modalExito, setModalExito] = useState({ open: false, mensaje: "" });
  const [modalError, setModalError] = useState({ open: false, mensaje: "" });
  const [modalEliminar, setModalEliminar] = useState(false);
  const [modalDetalle, setModalDetalle] = useState(false);
  const [ventasProducto, setVentasProducto] = useState([]);
  const [cargandoVentas, setCargandoVentas] = useState(false);

  const [formData, setFormData] = useState({
    empresa_id: 1,
    codigo_producto: "",
    codigo_barras: "",
    nombre: "",
    descripcion: "",
    categoria: "",
    precio_compra: 0,
    precio_venta: 0,
    stock_actual: 0,
    stock_minimo: 0,
    impuesto: 16,
    estatus: "activo",
  });

  useEffect(() => {
    fetchProductos();
  }, []);

  const fetchProductos = async () => {
    try {
      setLoading(true);
      const params = {};
      if (busqueda) params.search = busqueda;

      const response = await axios.get(API_ENDPOINTS.PRODUCTOS, { params });
      const productosData = response.data;

      const rows = productosData.map((producto) => ({
        producto: (
          <MDBox>
            <MDTypography variant="button" fontWeight="bold" fontSize="0.85rem" display="block">
              {producto.nombre}
            </MDTypography>
            <MDTypography variant="caption" color="text" fontSize="0.75rem">
              {producto.codigo_producto}
            </MDTypography>
          </MDBox>
        ),
        categoria: (
          <Chip
            label={producto.categoria || "General"}
            size="small"
            sx={{ fontSize: "0.7rem", height: "20px" }}
          />
        ),
        precio: (
          <MDTypography variant="button" fontSize="0.85rem" fontWeight="medium">
            {formatCurrency(producto.precio_venta)}
          </MDTypography>
        ),
        stock: (
          <Chip
            label={`${producto.stock_actual} unid.`}
            size="small"
            sx={{ fontSize: "0.7rem", height: "20px" }}
            color={producto.stock_actual <= producto.stock_minimo ? "error" : "success"}
          />
        ),
        estatus: (
          <Chip
            label={producto.estatus === "activo" ? "Activo" : "Inactivo"}
            size="small"
            sx={{ fontSize: "0.7rem", height: "20px" }}
            color={producto.estatus === "activo" ? "success" : "error"}
          />
        ),
        accion: (
          <MDBox display="flex" alignItems="center">
            <IconButton
              onClick={() => {
                setProductoSeleccionado(producto);
                handleVerDetalles(producto);
              }}
              size="small"
              color="info"
              title="Ver Detalles"
            >
              <Icon fontSize="small">visibility</Icon>
            </IconButton>
            <IconButton onClick={(e) => handleOpenMenu(e, producto)} size="small">
              <Icon fontSize="small">more_vert</Icon>
            </IconButton>
          </MDBox>
        ),
        _rawData: producto,
      }));

      const columns = [
        { Header: "Producto", accessor: "producto", width: "35%" },
        { Header: "Categoría", accessor: "categoria", width: "15%" },
        { Header: "Precio", accessor: "precio", width: "15%" },
        { Header: "Stock", accessor: "stock", width: "15%" },
        { Header: "Estado", accessor: "estatus", width: "12%" },
        { Header: "Acciones", accessor: "accion", width: "8%" },
      ];

      setProductos({ columns, rows });
      setLoading(false);
    } catch (error) {
      console.error("Error al cargar productos:", error);
      setLoading(false);
    }
  };

  const handleOpenMenu = (event, producto) => {
    setMenuAnchor(event.currentTarget);
    setProductoSeleccionado(producto);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleOpenModal = (editar = false) => {
    setModoEdicion(editar);
    if (!editar) {
      setFormData({
        empresa_id: 1,
        codigo_producto: "",
        codigo_barras: "",
        nombre: "",
        descripcion: "",
        categoria: "",
        precio_compra: 0,
        precio_venta: 0,
        stock_actual: 0,
        stock_minimo: 0,
        impuesto: 16,
        estatus: "activo",
      });
    } else if (productoSeleccionado) {
      setFormData(productoSeleccionado);
    }
    setOpenModal(true);
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        empresa_id: Number(formData.empresa_id) || 1,
        precio_compra: parseFloat(formData.precio_compra) || 0,
        precio_venta: parseFloat(formData.precio_venta) || 0,
        stock_actual: parseInt(formData.stock_actual) || 0,
        stock_minimo: parseInt(formData.stock_minimo) || 0,
        impuesto: parseFloat(formData.impuesto) || 0,
      };

      if (modoEdicion) {
        await axios.put(API_ENDPOINTS.PRODUCTO(productoSeleccionado.id), payload);
        setModalExito({ open: true, mensaje: "Producto actualizado exitosamente" });
      } else {
        await axios.post(API_ENDPOINTS.PRODUCTOS, payload);
        setModalExito({ open: true, mensaje: "Producto creado exitosamente" });
      }
      handleCloseModal();
      fetchProductos();
    } catch (error) {
      console.error("Error al guardar producto:", error);
      const mensajeError =
        error.response?.data?.message || error.response?.data?.errors
          ? Object.values(error.response.data.errors).flat().join(", ")
          : error.message;
      setModalError({ open: true, mensaje: `Error al guardar producto: ${mensajeError}` });
    }
  };

  const abrirModalEliminar = () => {
    setModalEliminar(true);
    handleCloseMenu();
  };

  const handleDelete = async () => {
    if (productoSeleccionado) {
      try {
        await axios.delete(API_ENDPOINTS.PRODUCTO(productoSeleccionado.id));
        setModalEliminar(false);
        setModalExito({ open: true, mensaje: "Producto eliminado exitosamente" });
        fetchProductos();
      } catch (error) {
        console.error("Error al eliminar producto:", error);
        setModalEliminar(false);
        setModalError({ open: true, mensaje: "Error al eliminar producto" });
      }
    }
  };

  const handleVerDetalles = async (producto = null) => {
    const targetProducto = producto || productoSeleccionado;
    if (targetProducto) {
      try {
        setModalDetalle(true);
        setCargandoVentas(true);
        handleCloseMenu();

        // Usamos el nuevo endpoint dedicado
        const response = await axios.get(API_ENDPOINTS.PRODUCTO_DETALLES(targetProducto.id));
        const { ventas } = response.data;

        setVentasProducto(ventas || []);
        setCargandoVentas(false);
      } catch (error) {
        console.error("Error al cargar detalles de ventas del producto:", error);
        setModalError({ open: true, mensaje: "Error al cargar el historial de ventas" });
        setCargandoVentas(false);
        setModalDetalle(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "USD",
    }).format(value);
  };

  return (
    <MDBox>
      <MDBox display="flex" mb={3} justifyContent="space-between">
        <MDButton variant="gradient" color={sidenavColor} onClick={() => handleOpenModal(false)}>
          <Icon>add_circle</Icon>&nbsp;Nuevo Producto
        </MDButton>
        <TextField
          placeholder="Buscar producto..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && fetchProductos()}
          size="small"
          sx={{ width: "300px" }}
          InputProps={{
            endAdornment: (
              <IconButton onClick={fetchProductos}>
                <Icon>search</Icon>
              </IconButton>
            ),
          }}
        />
      </MDBox>

      <Card>
        <MDBox p={3}>
          {loading ? (
            <MDTypography variant="body2" color="text">
              Cargando productos...
            </MDTypography>
          ) : (
            <DataTable
              table={productos}
              isSorted={false}
              entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20] }}
              showTotalEntries={true}
              noEndBorder
            />
          )}
        </MDBox>
      </Card>

      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleCloseMenu}>
        <MenuItem onClick={() => handleOpenModal(true)}>
          <Icon sx={{ mr: 1 }}>edit</Icon>
          Editar
        </MenuItem>
        <MenuItem onClick={handleVerDetalles}>
          <Icon sx={{ mr: 1 }}>visibility</Icon>
          Ver Detalles
        </MenuItem>
        <MenuItem onClick={abrirModalEliminar} sx={{ color: "error.main" }}>
          <Icon sx={{ mr: 1 }}>delete</Icon>
          Eliminar
        </MenuItem>
      </Menu>

      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            background: `linear-gradient(195deg, ${sidenavColor === "info"
              ? "#49a3f1"
              : sidenavColor === "success"
                ? "#66BB6A"
                : sidenavColor === "warning"
                  ? "#FFA726"
                  : sidenavColor === "error"
                    ? "#EF5350"
                    : "#344767"
              }, ${sidenavColor === "info"
                ? "#1A73E8"
                : sidenavColor === "success"
                  ? "#43A047"
                  : sidenavColor === "warning"
                    ? "#FB8C00"
                    : sidenavColor === "error"
                      ? "#E53935"
                      : "#1a2035"
              })`,
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <MDBox display="flex" alignItems="center">
            <Icon sx={{ mr: 1 }}>inventory_2</Icon>
            <MDTypography variant="h6" color="white">
              {modoEdicion ? "Editar Producto" : "Nuevo Producto"}
            </MDTypography>
          </MDBox>
          <IconButton onClick={handleCloseModal} sx={{ color: "white", padding: 0 }}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <MDInput
                name="codigo_producto"
                label="Código de Producto"
                value={formData.codigo_producto}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                name="codigo_barras"
                label="Código de Barras"
                value={formData.codigo_barras}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <MDInput
                name="nombre"
                label="Nombre del Producto"
                value={formData.nombre}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12}>
              <MDInput
                name="descripcion"
                label="Descripción"
                value={formData.descripcion}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={2}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <MDInput
                name="categoria"
                label="Categoría"
                value={formData.categoria}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                name="impuesto"
                type="number"
                label="Impuesto (%)"
                value={formData.impuesto}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <MDInput
                name="precio_compra"
                type="number"
                step="0.01"
                label="Precio de Compra"
                value={formData.precio_compra}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                name="precio_venta"
                type="number"
                step="0.01"
                label="Precio de Venta"
                value={formData.precio_venta}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <MDInput
                name="stock_actual"
                type="number"
                label="Stock Actual"
                value={formData.stock_actual}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                name="stock_minimo"
                type="number"
                label="Stock Mínimo"
                value={formData.stock_minimo}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton variant="outlined" color="secondary" onClick={handleCloseModal}>
            Cancelar
          </MDButton>
          <MDButton variant="gradient" color={sidenavColor} onClick={handleSubmit}>
            {modoEdicion ? "Actualizar" : "Guardar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal de Éxito */}
      <Dialog open={modalExito.open} onClose={() => setModalExito({ open: false, mensaje: "" })}>
        <DialogTitle
          sx={{
            background: "linear-gradient(195deg, #66BB6A, #43A047)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Icon>check_circle</Icon>
          Éxito
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <MDTypography variant="body1">{modalExito.mensaje}</MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="gradient"
            color="success"
            onClick={() => setModalExito({ open: false, mensaje: "" })}
          >
            Aceptar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal de Error */}
      <Dialog open={modalError.open} onClose={() => setModalError({ open: false, mensaje: "" })}>
        <DialogTitle
          sx={{
            background: "linear-gradient(195deg, #EF5350, #E53935)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Icon>error</Icon>
          Error
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <MDTypography variant="body1">{modalError.mensaje}</MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="gradient"
            color="error"
            onClick={() => setModalError({ open: false, mensaje: "" })}
          >
            Aceptar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal de Confirmación de Eliminación */}
      <Dialog open={modalEliminar} onClose={() => setModalEliminar(false)}>
        <DialogTitle
          sx={{
            background: "linear-gradient(195deg, #EF5350, #E53935)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Icon>warning</Icon>
          Confirmar Eliminación
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {productoSeleccionado && (
            <MDBox>
              <MDTypography variant="body1" mb={2}>
                ¿Está seguro de que desea eliminar este producto?
              </MDTypography>
              <Card
                sx={{
                  background: "linear-gradient(195deg, #ffebee, #ffcdd2)",
                  p: 2,
                  border: "1px solid #ef5350",
                }}
              >
                <MDTypography variant="button" fontWeight="bold" display="block">
                  {productoSeleccionado.nombre}
                </MDTypography>
                <Divider sx={{ my: 1 }} />
                <MDTypography variant="caption" display="block">
                  Código: {productoSeleccionado.codigo_producto}
                </MDTypography>
                <MDTypography variant="caption" display="block">
                  Precio: {formatCurrency(productoSeleccionado.precio_venta)}
                </MDTypography>
                <MDTypography variant="caption" display="block">
                  Stock: {productoSeleccionado.stock_actual} unidades
                </MDTypography>
              </Card>
              <MDTypography variant="caption" color="error" mt={2} display="block">
                Esta acción no se puede deshacer.
              </MDTypography>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="secondary" onClick={() => setModalEliminar(false)}>
            Cancelar
          </MDButton>
          <MDButton variant="gradient" color="error" onClick={handleDelete}>
            Eliminar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal Detalle de Producto */}
      <Dialog
        open={modalDetalle}
        onClose={() => setModalDetalle(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          }
        }}
      >
        <DialogTitle
          sx={{
            background: `linear-gradient(195deg, ${sidenavColor === "info" ? "#49a3f1" :
              sidenavColor === "success" ? "#66BB6A" :
                sidenavColor === "warning" ? "#FFA726" :
                  sidenavColor === "error" ? "#EF5350" : "#344767"
              }, ${sidenavColor === "info" ? "#1A73E8" :
                sidenavColor === "success" ? "#43A047" :
                  sidenavColor === "warning" ? "#FB8C00" :
                    sidenavColor === "error" ? "#E53935" : "#1a2035"
              })`,
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <MDBox display="flex" alignItems="center">
            <Icon sx={{ mr: 1 }}>info</Icon>
            <MDBox>
              <MDTypography variant="h6" color="white">
                Detalles del Producto
              </MDTypography>
              {productoSeleccionado && (
                <MDTypography variant="caption" color="white" opacity={0.8}>
                  {productoSeleccionado.nombre} | Código: {productoSeleccionado.codigo_producto}
                </MDTypography>
              )}
            </MDBox>
          </MDBox>
          <IconButton onClick={() => setModalDetalle(false)} sx={{ color: "white", padding: 0 }}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          {cargandoVentas ? (
            <MDBox py={3} textAlign="center">
              <MDTypography variant="body2" color="text">
                Cargando historial de ventas...
              </MDTypography>
            </MDBox>
          ) : ventasProducto.length === 0 ? (
            <MDBox py={3} textAlign="center">
              <MDTypography variant="body2" color="text">
                No hay ventas registradas para este producto.
              </MDTypography>
            </MDBox>
          ) : (
            <MDBox>
              <MDTypography variant="h6" fontWeight="bold" mb={2}>
                Historial de Ventas
              </MDTypography>
              <Table size="small">
                <TableHead sx={{ display: "table-header-group" }}>
                  <TableRow>
                    <TableCell><MDTypography variant="caption" fontWeight="bold">Fecha</MDTypography></TableCell>
                    <TableCell><MDTypography variant="caption" fontWeight="bold">Cliente</MDTypography></TableCell>
                    <TableCell align="right"><MDTypography variant="caption" fontWeight="bold">Precio Unit.</MDTypography></TableCell>
                    <TableCell align="center"><MDTypography variant="caption" fontWeight="bold">Cant.</MDTypography></TableCell>
                    <TableCell align="right"><MDTypography variant="caption" fontWeight="bold">Total Venta</MDTypography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ventasProducto.map((venta, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <MDTypography variant="caption" color="text">
                          {new Date(venta.fecha).toLocaleDateString("es-ES")}
                        </MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="caption" color="text">
                          {venta.cliente}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="caption" color="text">
                          {formatCurrency(venta.precio_unitario)}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="center">
                        <MDTypography variant="caption" color="text">
                          {venta.cantidad}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="caption" fontWeight="bold">
                          {formatCurrency(venta.total_producto)}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </MDBox>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton variant="gradient" color="dark" onClick={() => setModalDetalle(false)}>
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>
    </MDBox>
  );
}
